import { render } from "./CheckOutIndex.vue?vue&type=template&id=4505898a&scoped=true"
import script from "./CheckOutIndex.vue?vue&type=script&lang=js"
export * from "./CheckOutIndex.vue?vue&type=script&lang=js"

import "./CheckOutIndex.vue?vue&type=style&index=0&id=4505898a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4505898a"]])

export default __exports__